import React from "react";
import SocCoverageIcons from "../Icons/SocCoverageIcons";
import CounterCircle from "../CounterCircle/CounterCircle";

interface IGeneralCoverageCard{
  title: string;
  subtitle?: string;
  counterCurrent?: number;
  counterMax?: number;
  isSurgical?:boolean
}

const GeneralCoverageCard = ({
  title,
  subtitle="",
  counterCurrent,
  counterMax,
  isSurgical,
}: IGeneralCoverageCard) => {
  return (
    <div className="flex-1 bg-white p-3 flex flex-col justify-center items-center rounded-lg gap-2">
      {isSurgical?(<SocCoverageIcons isComplete={counterCurrent==counterMax&& counterCurrent!=undefined}/>):(
        counterCurrent!==undefined && counterMax!==undefined?
          <CounterCircle currentValue={counterCurrent} maxValue={counterMax} />:
          <SocCoverageIcons />)}
      <div className="text-center">
        <div className="text-sm font-semibold">{title}</div>
        <div className="text-xs text-gray-1">{subtitle}</div>
      </div>
    </div>
  );
};

export default GeneralCoverageCard;
